<template>
  <div>
    <div class="mt-5">
      <h4>{{$t('CONTENT.indexation.indexation')}}</h4>
      <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
        <div class="col-5">
          <label>{{$t('CONTENT.indexation.indexation_kind')}}:<span class="b-form__required"> *</span></label>
          <cool-select :list="availableIndexations"
                       option-value="id"
                       option-text="name"
                       :placeholder="$t('CONTENT.choose')"
                       :isError="isFieldWithError('indexationKindId', payment.indexation.indexationKindId)"
                       v-model="payment.indexation.indexationKindId"></cool-select>
        </div>
        <div class="col-4">
          <label>{{$t('CONTENT.indexation.firstIndexationDate')}}:</label>
          <datepicker class="b-datepicker" v-model="firstIndexationDate" :disabled="isDisabledIndexationDate" :formatter="datepickerFormat" :disabled-date="disabledDate"/>
        </div>
        <div class="col-3">
          <label>{{$t('CONTENT.percent')}}:</label>
          <numeric class="b-numeric" controls :min="0" :max="100" :disabled="isDisabledIndexationPercent" v-model="indexationPercent"></numeric>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-6">
          <label for="comment">{{$t('CONTENT.comment')}}:</label>
          <textarea id="comment" class="b-textarea" v-model="payment.indexation.commentary" :disabled="isDisabledIndexationComment"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import dateConverter from "../../../utils/converters/date.converter";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  props: {
    payment: {
      type: Object
    },
    paymentsName: {
      type: Array
    },
    validationErrors: {
      type: Array
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      isDisabledIndexationDate: false,
      isDisabledIndexationPercent: false,
      isDisabledIndexationComment: false,
      availableIndexations: [],
    }
  },
  created() {
    this.availableIndexations = this.allIndexations;
    this.updateIndexation();
  },
  watch: {
    'payment.paymentNameId'(newVal) {
      if(newVal !== null) {
        this.availableIndexations = [];

        for (let i = 0; i < this.paymentsName.length; i++) {
          let currentPaymentNameTypeCode = this.paymentsName[i].paymentTypeCode;
          let currentPaymentNameKindCode = this.paymentsName[i].paymentKindCode;

          let isPaymentWithoutIndexation = currentPaymentNameTypeCode === 'penalty_payment' ||
            currentPaymentNameTypeCode === 'residual_value_guarantees' ||
            currentPaymentNameTypeCode === 'purchase_option' ||
            currentPaymentNameTypeCode === 'variable_lease_payment_not_depend_on_index' ||
            (currentPaymentNameTypeCode === 'fixed_lease_payment' && currentPaymentNameKindCode === "upfront_payment");

          if(this.paymentsName[i].idInDB === newVal) {
            if(isPaymentWithoutIndexation) {
              this.availableIndexations = this.allIndexations.filter(elem => elem.typeNumber === 4);
              this.resetIndexationKindId();
              return;
            }
          } else {
            this.availableIndexations = this.allIndexations;
            this.resetIndexationKindId();
          }
        }
      }
    },
    'payment.indexation.indexationKindId'() {
      this.updateIndexation();
    }
  },
  computed: {
    allIndexations() {
      return this.$store.getters['indexationPlugin/getAllIndexations'];
    },
    firstIndexationDate: {
      get() {
        if (this.payment.indexation.firstIndexationDate === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.payment.indexation.firstIndexationDate);
        }
      },
      set(newVal) {
        if(newVal !== null) {
          this.payment.indexation.firstIndexationDate = dateConverter.convertToString(newVal);
        } else {
          this.payment.indexation.firstIndexationDate = null;
        }
      }
    },
    indexationPercent: {
      get() {
        if (this.payment.indexation.indexationPercent !== null) {
          return this.payment.indexation.indexationPercent;
        }
      },
      set(newVal) {
        this.payment.indexation.indexationPercent = newVal;
      }
    },
    discountPercent: {
      get() {
        if (this.payment.indexation.discountPercent !== null) {
          return this.payment.indexation.discountPercent;
        }
      },
      set(newVal) {
        this.payment.indexation.discountPercent = newVal;
      }
    }
  },
  methods: {
    resetIndexationKindId() {
      this.payment.indexation.indexationKindId = null;
    },
    updateIndexation() {
      let chosenIndexation = null;
      if(this.payment.indexation.indexationKindId !== null) {
        for (let i = 0; i < this.allIndexations.length; i++) {
          if(this.allIndexations[i].id === this.payment.indexation.indexationKindId) {
            chosenIndexation = this.allIndexations[i];
          }
        }

        if(chosenIndexation.typeNumber === 4) {
          this.payment.indexation.firstIndexationDate = null;
          this.payment.indexation.indexationPercent = null;

          this.isDisabledIndexationDate = true;
          this.isDisabledIndexationPercent = true;
        } else if(chosenIndexation.typeNumber === 3) {
          this.isDisabledIndexationDate = false;
          this.isDisabledIndexationPercent = true;

          this.payment.indexation.indexationPercent = 0;
        } else {
          this.isDisabledIndexationDate = false;
          this.isDisabledIndexationPercent = false;
          if (this.payment.indexation.indexationPercent === 0) {
            this.payment.indexation.indexationPercent = null;
          }
        }
      }
    },
    isFieldWithError(field, value) {
      return !value && this.validationErrors && this.validationErrors.includes(field);
    },
    disabledDate(date) {
      const startDate = this.payment.startDate
      if(startDate === null || startDate === '') return false
      return date < dateConverter.convertToDate(startDate)
    }
  }
};
</script>
